import { TMS_THEME } from "../theming/theming";
export var calculateColor = function (color) {
    switch (color) {
        case "primary":
            return TMS_THEME.palette.primary.base.color;
        case "secondary":
            return TMS_THEME.palette.secondary.base.color;
        case "smoke":
            return TMS_THEME.palette.gray.smoke.color;
        case "aliceBlue":
            return TMS_THEME.palette.gray.aliceBlue.color;
        case "cloud":
            return TMS_THEME.palette.gray.cloud.color;
        case "fog":
            return TMS_THEME.palette.gray.fog.color;
        case "white":
            return TMS_THEME.palette.gray.white.color;
        default:
            return {};
    }
};
